var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommunityIcon = function SvgCommunityIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A1A1AA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.64,
    d: "M20 14.667a1.78 1.78 0 0 1-1.778 1.777H7.556L4 20V5.778A1.78 1.78 0 0 1 5.778 4h12.444A1.78 1.78 0 0 1 20 5.778z"
  })));
};
export default SvgCommunityIcon;